import { TFunction } from 'react-i18next'
import { DataTableCellVariants } from '@node-space/ui-components'
import { ApprovalsProcessedBy } from 'types/approvals'
import { ApprovalTableType, ApprovalTableTypes } from './types'

export const getProcessedByDetails = (
  processedBy: ApprovalsProcessedBy[],
  status: string,
  t: TFunction
) => {
  const filteredProcessedBy = processedBy?.filter(
    processedByDetail => processedByDetail?.status === status
  )

  const isProcessedByMultiple = filteredProcessedBy && filteredProcessedBy?.length > 1
  const isProcessedBySingle = filteredProcessedBy && filteredProcessedBy?.length === 1
  const processedByCount = processedBy?.length

  if (!processedByCount) {
    return {
      isProcessedByMultiple: false,
      isProcessedBySingle: false,
      processedByText: '',
    }
  }

  const processedByCountText =
    processedByCount === 2
      ? t('approvals.plusOneOther', { count: processedByCount - 1 })
      : t('approvals.plusOthers', { count: processedByCount - 1 })
  const processedByText =
    processedByCount === 1
      ? (filteredProcessedBy[0]?.userFullName ?? filteredProcessedBy[0]?.email)
      : `${filteredProcessedBy[0]?.userFullName ?? filteredProcessedBy[0]?.email} ${processedByCountText}`

  return {
    isProcessedByMultiple,
    isProcessedBySingle,
    processedByText,
  }
}

export const getTableHeaders = (t: TFunction, tableType: ApprovalTableType) => {
  const defaultHeaders = [
    {
      key: 'payment',
      label: t('payment'),
      variant: DataTableCellVariants.TEXT,
    },
    {
      key: 'to',
      label: t('to'),
      variant: DataTableCellVariants.TEXT,
    },
  ]

  switch (tableType) {
    case ApprovalTableTypes.APPROVED:
      return [
        ...defaultHeaders,
        {
          key: 'approvedBy',
          label: t('approvals.approvedBy'),
          variant: DataTableCellVariants.TEXT,
        },
      ]
    case ApprovalTableTypes.PENDING:
      return [
        ...defaultHeaders,
        {
          key: 'approvalsInitiatedBy',
          label: t('approvals.initiatedBy'),
          variant: DataTableCellVariants.TEXT,
        },
        {
          key: 'approvalsRequired',
          label: t('approvals.required'),
          variant: DataTableCellVariants.TEXT,
        },
      ]
    case ApprovalTableTypes.REJECTED:
      return [
        ...defaultHeaders,
        {
          key: 'initiatedBy',
          label: t('approvals.initiatedBy'),
          variant: DataTableCellVariants.TEXT,
        },
        {
          key: 'rejectedBy',
          label: t('approvals.rejectedBy'),
          variant: DataTableCellVariants.TEXT,
        },
        {
          key: 'reasonForRejection',
          label: t('approvals.reasonForRejection'),
          variant: DataTableCellVariants.TEXT,
        },
      ]
    case ApprovalTableTypes.EXPIRED:
      return [
        ...defaultHeaders,
        {
          key: 'approvalsInitiatedBy',
          label: t('approvals.initiatedBy'),
          variant: DataTableCellVariants.TEXT,
        },
        {
          key: 'dateOfExpiry',
          label: t('approvals.dateOfExpiry'),
          variant: DataTableCellVariants.TEXT,
        },
      ]
  }
}
